module.exports = __webpack_public_path__ + "static/img/noPermission.74f10002.png";